import React from 'react';
import { graphql } from 'gatsby';
import { HelmetDatoCms } from '@rasahq/gatsby-source-datocms';
import { SiteLayout } from '@rasahq/react-tabula';

import HeroHeader from 'src/modules/summit/hero-header';
import PostShowArchive from 'src/modules/summit/post-show-archive';
import Banner from 'src/partials/banner';
import Footer from 'src/partials/footer';

const components = {
  'summit/hero-header': HeroHeader,
  'summit/post-show-archive': PostShowArchive,
};

export default function Page({ data: { datoCmsSite: site, datoCmsPage: page } }) {
  const Header = components[page.header.moduleComponent.filePath];
  return (
    <SiteLayout>
      <HelmetDatoCms seo={page.seoMetaTags} />
      {/* <Banner /> */}
      <Header {...page.header} />
      {page.drawers.map((drawer, i) => {
        const Drawer = components[drawer.moduleComponent.filePath];
        drawer.odd = i % 2 === 0;
        return Drawer ? <Drawer key={i} {...drawer} /> : null;
      })}
      <Footer />
    </SiteLayout>
  );
}

export const query = graphql`
  {
    datoCmsPage(slug: { eq: "summit" }) {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      slug
      header {
        moduleComponent {
          filePath
        }
        preHeading
        preHeadingNode {
          childMarkdownRemarkInline {
            html
          }
        }
        heading
        headingNode {
          childMarkdownRemarkInline {
            html
          }
        }
        content
        contentNode {
          childMarkdownRemark {
            html
          }
        }
        image {
          width
          height
          url
          fixed(width: 180, height: 180) {
            ...GatsbyDatoCmsFixed
          }
        }
        ctas {
          a11yText
          text
          url
        }
      }
      drawers {
        moduleComponent {
          filePath
        }
        preHeadingNode {
          childMarkdownRemarkInline {
            html
          }
        }
        heading
        headingNode {
          childMarkdownRemarkInline {
            html
          }
        }
        content
        contentNode {
          childMarkdownRemark {
            html
          }
        }
        image {
          width
          height
          url
          fixed(width: 180, height: 180) {
            ...GatsbyDatoCmsFixed
          }
        }
        callouts {
          ... on DatoCmsCallout {
            heading
            headingNode {
              childMarkdownRemarkInline {
                html
              }
            }
            content
            contentNode {
              childMarkdownRemark {
                html
              }
            }
            ctas {
              text
              a11yText
              url
            }
            customData
          }
        }
        ctas {
          text
          a11yText
          url
        }
      }
    }

    datoCmsSite {
      faviconMetaTags {
        ...GatsbyDatoCmsFaviconMetaTags
      }
      globalSeo {
        siteName
        titleSuffix
        twitterAccount
        facebookPageUrl
        fallbackSeo {
          title
          description
          image {
            url
          }
          twitterCard
        }
      }
    }
  }
`;
